import { HelpParseKeyValueString2 } from "helpers/HelpParseKeyValueString";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import GWPagosAvatarCss from "components/GWAvatar/GWPagosAvatar.css";

const GWPagosAvatar = () => {
  const estiloCentrado = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100vh", // O ajusta la altura según tus necesidades
  };
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [urls, setUrls] = useState({
    urlDone: "",
    urlPending: "",
    urlFailed: "",
  });
  const [allParams, setAllParams] = useState({});
  useEffect(() => {
    console.log({location, searchParams});
    if (searchParams) {
      const { callback_url, tran_id, ...rest } = HelpParseKeyValueString2(
        location.search
      );
      // Crea un nuevo objeto que contenga todo junto
      let newAllParams = {};
      if (callback_url && tran_id) {
        newAllParams = { callback_url, tran_id, ...rest };
      }
      console.log({newAllParams})
      setAllParams(newAllParams);
      const urlsList = ["DONE", "PENDING", "FAILED"];
      // Array para almacenar las URLs generadas
      const generatedUrls = [];

      urlsList.forEach((url, index) => {
        const generatedUrl = `${callback_url}`;
        if (url === "DONE") generatedUrls.urlDone = generatedUrl;
        else if (url === "PENDING") generatedUrls.urlPending = generatedUrl;
        else if (url === "FAILED") generatedUrls.urlFailed = generatedUrl;
      });

      setUrls(generatedUrls);
    }
  }, [location]);

  const handleButtonClick = (url) => {
    if (url) {
      window.location.href = url;
    }
  };

  return (
    <div className="container" style={estiloCentrado}>
      <div className="Contenido-GWavatar">
        <h2>GW Pagos Avatar</h2>
        <div className="Contenido-Body">
          <ol className="lista-body">
            {Object.entries(allParams).length > 0 ? (
              Object.entries(allParams).map(([key, value]) => (
                <li key={key}>
                  <strong>{key}:</strong> {value}
                </li>
              ))
            ) : (
              <li>No se encontró parametros</li>
            )}
          </ol>
        </div>

        <div className="contenido-botones">
          <button
            className="dimension-botones"
            onClick={() => handleButtonClick(urls.urlDone)}
            style={{ backgroundColor: "#28a745" }}
          >
            DONE
          </button>
          <button
            className="dimension-botones"
            onClick={() => handleButtonClick(urls.urlPending)}
            style={{ backgroundColor: "#ffc107" }}
          >
            PENDING
          </button>
          <button
            className="dimension-botones"
            onClick={() => handleButtonClick(urls.urlFailed)}
            style={{ backgroundColor: "#dc3545" }}
          >
            FAILED
          </button>
        </div>
      </div>
    </div>
  );
};
export default GWPagosAvatar;
